module.exports = __webpack_public_path__ + "static/media/about2.4099dc29.webp";